import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
	GET_OUTING_PUNCH_SETTING_CALL,
	GET_OUTING_PUNCH_SETTING_DONE,
	GET_OUTING_PUNCH_SETTING_FAIL,
	GET_OUTING_PUNCH_CALL,
	GET_OUTING_PUNCH_DONE,
	GET_OUTING_PUNCH_FAIL,
	GET_OUTING_PUNCH_ATTACHMENT_DONE,
	DELETE_OUTING_PUNCH_CALL,
	DELETE_OUTING_PUNCH_DONE,
	DELETE_OUTING_PUNCH_FAIL,
	POST_OUTING_PUNCH_CALL,
	POST_OUTING_PUNCH_DONE,
	POST_OUTING_PUNCH_FAIL,
	POST_OUTING_PUNCH_ATTACHMENTS_CALL,
	POST_OUTING_PUNCH_ATTACHMENTS_DONE,
	POST_OUTING_PUNCH_ATTACHMENTS_FAIL,
} from '@src/store/types/outingPunch';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	outingPunchSetting: {},
	getOutingPunchSettingSideEffect: defaultSideEffectState,
	outingPunchList: [],
	getOutingPunchListSideEffect: defaultSideEffectState,
	deleteOutingPunchSideEffect: defaultSideEffectState,
	outingPunchAttachmentMap: {},
	postOutingPunchListSideEffect: defaultSideEffectState,
	postOutingPunchAttachmentsSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_OUTING_PUNCH_SETTING_CALL](state) {
		return update(state, {
			getOutingPunchSettingSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_OUTING_PUNCH_SETTING_DONE](state, { payload: { res } }) {
		return update(state, {
			outingPunchSetting: { $set: res },
			getOutingPunchSettingSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_OUTING_PUNCH_SETTING_FAIL](state, { payload }) {
		return update(state, {
			getOutingPunchSettingSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_OUTING_PUNCH_CALL](state, { payload }) {
		if (payload?.silent) return state;
		return update(state, {
			getOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_OUTING_PUNCH_DONE](state, { payload: { res } }) {
		return update(state, {
			outingPunchList: { $set: res?.data || [] },
			getOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_OUTING_PUNCH_FAIL](state, { payload }) {
		return update(state, {
			getOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[DELETE_OUTING_PUNCH_CALL](state) {
		return update(state, {
			deleteOutingPunchSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[DELETE_OUTING_PUNCH_DONE](state) {
		return update(state, {
			deleteOutingPunchSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[DELETE_OUTING_PUNCH_FAIL](state, { payload }) {
		return update(state, {
			deleteOutingPunchSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_OUTING_PUNCH_ATTACHMENT_DONE](state, { payload: { id, url } }) {
		return update(state, {
			outingPunchAttachmentMap: {
				[id]: { $set: url },
			},
		});
	},
	[POST_OUTING_PUNCH_CALL](state) {
		return update(state, {
			postOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_OUTING_PUNCH_DONE](state) {
		return update(state, {
			postOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_OUTING_PUNCH_FAIL](state, { payload }) {
		return update(state, {
			postOutingPunchListSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[POST_OUTING_PUNCH_ATTACHMENTS_CALL](state) {
		return update(state, {
			postOutingPunchAttachmentsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_OUTING_PUNCH_ATTACHMENTS_DONE](state) {
		return update(state, {
			postOutingPunchAttachmentsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_OUTING_PUNCH_ATTACHMENTS_FAIL](state, { payload }) {
		return update(state, {
			postOutingPunchAttachmentsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
